import { createEventFactory, createName } from '@cp/shared/tracking';

export const LoginButtonClickEvent = createEventFactory<void>({
  name: createName('auth', 'login'),
  goalId: 'nazhatie_na_knopku_vojti_v_navigacii',
  goalName: 'Нажатие на кнопку "Войти" в навигации',
});

export const LoginModalOpened = createEventFactory<void>({
  name: createName('auth', 'popup', 'open'),
  goalId: 'poyavlenie_popapa_s_nomerom_telefona',
  goalName: 'Появление попапа с номером телефона',
  nonInteraction: true,
});

export const AuthByPhoneFormSubmit = createEventFactory<void>({
  name: createName('auth', 'phone', 'submit'),
  goalId: 'nazhatie_na_knopku_poluchit_kod_v_popape_avtorizacii',
  goalName: 'Нажатие на кнопку "Получить код" в попапе авторизации',
});

export const AuthSMSCodeSubmit = createEventFactory<{ status: string }>({
  name: createName('auth', 'otp', 'submit'),
  goalId: 'vvod_koda_pri_avtorizacii',
  goalName: 'Ввод кода при авторизации',
});
